"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupRoleBranchEventTypes = void 0;
var GroupRoleBranchEventTypes;
(function (GroupRoleBranchEventTypes) {
    GroupRoleBranchEventTypes["ADD"] = "group-role-branch-add";
    GroupRoleBranchEventTypes["UPDATE"] = "group-role-branch-update";
})(GroupRoleBranchEventTypes || (exports.GroupRoleBranchEventTypes = GroupRoleBranchEventTypes = {}));
